import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/img.png'
import _imports_1 from './_images/img_1.png'
import _imports_2 from './_images/img_2.png'
import _imports_3 from './_images/img_3.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1273f44c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "隐性水印查看教程", -1))
const _hoisted_3 = { class: "item-wrapper" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"item-wrapper\" data-v-1273f44c><div class=\"title\" data-v-1273f44c>2、打开后，将要显形的隐性水印图片导入并替换该文件中的“带隐性水印图片模板”；</div><img class=\"cm-ui-mt10\" src=\"" + _imports_0 + "\" alt=\"\" data-v-1273f44c></div><div class=\"item-wrapper\" data-v-1273f44c><div class=\"title\" data-v-1273f44c>3、替换成功后，请勿调整三个图层的顺序，再此基础上分别点击“深色背景”或“浅色背景”的小眼睛按钮，可查看显形效果，借助其一显形即可；</div><img class=\"cm-ui-mt10\" src=\"" + _imports_1 + "\" alt=\"\" data-v-1273f44c></div><div class=\"item-wrapper\" data-v-1273f44c><div class=\"title\" data-v-1273f44c>4、若通过以上步骤都难以显形，可通过新增曲线图层，调整曲线进行显形。</div><img class=\"cm-ui-mt10\" src=\"" + _imports_2 + "\" alt=\"\" data-v-1273f44c><img class=\"cm-ui-mt10\" src=\"" + _imports_3 + "\" alt=\"\" data-v-1273f44c></div><br data-v-1273f44c><br data-v-1273f44c>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(" 1、首先，先下载《隐性水印查看文件》，"),
        _createElementVNode("span", {
          class: "cm-link-light",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadPsFile && _ctx.downloadPsFile(...args)))
        }, "点击此处下载"),
        _createTextVNode("，再使用Photoshop打开此文件； ")
      ])
    ]),
    _hoisted_5
  ]))
}